export const parseTableAnswer = (
  answer,
  questionId,
  rowsCount,
  columnsCount,
) => {
  if (!answer) return [];

  const cells = answer.split("__");
  const result = [];

  let index = 0;

  for (let row = 0; row < rowsCount; row++) {
    for (let col = 0; col < columnsCount; col++) {
      result.push({
        questionId,
        rowIndex: row,
        columnIndex: col,
        answer: cells[index] ?? "",
      });

      index++;
    }
  }

  return result;
};

export const serializeTableAnswer = (
  formData,
  questionId,
  rowsCount,
  columnsCount,
) => {
  const values = [];

  for (let row = 0; row < rowsCount; row++) {
    for (let col = 0; col < columnsCount; col++) {
      const item = formData.find(
        (x) =>
          x.questionId === questionId &&
          x.rowIndex === row &&
          x.columnIndex === col,
      );

      values.push(item?.answer ?? "");
    }
  }

  return values.join("__");
};

export const findQuestionById = (id, questions) => {
  for (const q of questions?.questions || []) {
    if (q.id === id) return q;

    if (q.questionType === "GROUP") {
      const child = q.questions?.find((x) => x.id === id);

      if (child) return child;
    }
  }

  return null;
};
